export const MAX_PAGE_WIDTH = 1512;
